/**
 * Joins class names, filtering out falsy values
 *
 * @param classes - Class names to join (strings, conditionals, arrays)
 * @returns Joined class name string
 *
 * @example
 * cx('button', isActive && 'active', 'large') // 'button active large'
 * cx('card', false, null, undefined, 'shadow') // 'card shadow'
 * cx(['flex', 'items-center'], 'gap-4') // 'flex items-center gap-4'
 */
export function cx(...classes: (string | boolean | null | undefined | string[])[]): string {
  return classes
    .flat()
    .filter((cls): cls is string => typeof cls === 'string' && cls.trim().length > 0)
    .map((cls) => cls.trim())
    .join(' ');
}
